import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { INN_PATTERN } from '@components/daData';

import { IStep5 } from '../../../interfaces';

export const ValidationSchema = (t: TFunction<Namespace<'validation'>>): Yup.SchemaOf<IStep5> =>
  Yup.object().shape({
    company_name: Yup.string().required(t('required')),
    inn: Yup.string().required(t('required')).matches(INN_PATTERN, t('innFormat')),
  });
